import React from 'react';

const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      company: 'Charleston Medical Center',
      role: 'Facilities Manager',
      content: 'Professional Office Group transformed our entire medical office with beautiful, functional furniture. Their design expertise and installation service were exceptional. Best prices we found in South Carolina!',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/153af25c0e797bd89fe12e4846426b59.jpg'
    },
    {
      name: 'Michael Rodriguez',
      company: 'Greenville Tech Solutions',
      role: 'CEO',
      content: 'Amazing quality furniture and outstanding customer service. POG helped us create a modern workspace that our employees love. The delivery and installation were flawless.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20businessman%20in%20modern%20tech%20office%2C%20confident%20smile%2C%20business%20suit%2C%20contemporary%20office%20environment%20with%20technology%20elements%20in%20background&width=80&height=80&seq=testimonial-michael&orientation=squarish'
    },
    {
      name: 'Jennifer Davis',
      company: 'Columbia Law Firm',
      role: 'Office Administrator',
      content: 'We needed to furnish our new law office quickly and professionally. POG delivered exactly what we needed on time and within budget. Highly recommend their services!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20in%20law%20office%20setting%2C%20confident%20and%20approachable%2C%20wearing%20professional%20attire%2C%20legal%20office%20background%20with%20bookshelves%20and%20elegant%20furniture&width=80&height=80&seq=testimonial-jennifer&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our <strong>South Carolina</strong> Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover why businesses across South Carolina trust Professional Office Group 
            for their office furniture needs and exceptional service experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.content}"
              </p>
              <div className="flex items-center">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                  <p className="text-sm text-blue-600 font-medium">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;